export const FAQ_CONSTANTS = {
  SECTION_ID: 'faq',
  TITLE_ID: 'faq-title',
  SECTION_TITLE: '💒 Wedding FAQs',
  EMAIL: 'shubhankarpataskar@gmail.com',
  
  FAQS: {
    ACCOMMODATION: {
      KEY: 'accommodation',
      QUESTION: '🏨 Where can we stay?',
      ANSWER: `Travelling in from out of town? Don't worry! we've got you covered! 
If you're coming from outside Pune on the 27th & 28th December, or from outside Mumbai on 2nd Jan, we'll be arranging your stay at a cozy hotel close to the venue for the 27th night and/or the 2nd night.`,
    },
    VENUES: {
      KEY: 'venues',
      QUESTION: '🕐 How and when should we get to the venues?',
      ANSWER: `All event timings and locations are mentioned in the invite - make sure to check it out! 
If you're joining us in Pune, we suggest arriving by the 28th, so you don't miss any of the pre-wedding fun! Punctuality = more time for masti! 💃🕺`,
    },
    ATTIRE: {
      KEY: 'attire',
      QUESTION: '👗 What should we wear?',
      ANSWER: `No strict dress codes here 😊 just bring your best desi fashion game! 
Think colorful, festive, and totally you. 
From lehengas to kurta sets, sarees to sherwanis — if it makes you want to twirl or take a selfie, it's perfect. ✨`,
    },
    CONTACT: {
      KEY: 'contact',
      QUESTION: '📞 Who can I contact if I have questions?',
      ANSWER: `If you're unsure about travel, logistics, or anything wedding-related, reach out to either of our families - they're basically our superhero team. 
Or drop us an email at {EMAIL} or call on +919175557213 and we'll try to get back to you faster than you can say shaadi season! 💌`,
    },
  },
};